<template>

  <aside class=" lg:block min-w-[273px] relative aside-filter"
         :class="[{ 'hidden' : !(modal && isMobile)}, `h-[${blockHeight}px]`]">
    <div class="max-md:w-full h-full   absolute top-0 left-0 right-0 bottom-0 " :class="{'overflow-auto' : isMobile}">
      <header class="bg-white flex flex-column justify-between p-3 px-6 items-center sticky top-0 z-30 shadow-md" v-if="isMobile">
        <div class="text-black font-hebrew text-[29px]/[20px] font-bold">{{ title }}</div>
        <div class="flex gap-4">
          <button @click="resetFilter" class="px-[15px] cursor-pointer flex items-center bg-vivid-purple  rounded-small justify-center py-[6px] sm:py-3 text-white gap-[13px] sm:gap-5 hover:opacity-70 transition-all duration-200 ease-linear">Reset</button>
          <button @click="closeModal" class="px-[15px] cursor-pointer flex items-center bg-vivid-purple  rounded-small justify-center py-[6px] sm:py-3 text-white gap-[13px] sm:gap-5 hover:opacity-70 transition-all duration-200 ease-linear">Close</button>
        </div>
      </header>
      <div class="rounded-small border  px-6 lg:px-[15px] relative z-20" dir="rtl"
           :class="{'h-full' : status && !isMobile, 'overflow-auto border-vivid-purple' : !isMobile, ' border-0': isMobile}">
        <button
            type="button"
            v-on:click="toggle"
            v-if="!isMobile"
            class="bg-white text-black border-b-[1px] font-hebrew text-[29px]/[20px] flex justify-between w-full items-center py-4 gap-[12px] sticky top-0 z-[60]"
            :class="{
            ' border-vivid-purple': status
          }"
        >
          <span class="flex-1 text-right font-bold">{{ title }}</span>
          <IconDropdown :class="{'rotate-180': !status}" class="w-[16px] h-[16px] fill-black"/>
        </button>

        <div v-if="status" class="flex-column my-[20px] gap-[16px]">
          <template v-for="(item) in filters.years" :key="key">
            <Checkbox :label="item" v-model="selected" :value="item" class="mb-4 text-[30px]"/>
          </template>
        </div>
      </div>
    </div>
  </aside>

    <div class="block lg:hidden fixed right-[23px] top-[131px]">
      <button
          @click="openModal"
          class="px-[15px] cursor-pointer flex items-center bg-vivid-purple h-[43px] sm:h-[54px] rounded-small justify-center py-[6px] sm:py-3  text-white gap-[13px] sm:gap-5 mt-3 hover:opacity-70 transition-all duration-200 ease-linear">
        {{ title }}
      </button>
    </div>
</template>


<style>

@media screen and (max-width: 1023px) {
  .aside-filter {
    position: fixed!important;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height:auto!important;
    z-index: 9999;
    background: #ffffff;
  }
}
</style>
<script lang="ts">
import {ref, defineComponent, watch, onMounted, onUnmounted} from "vue";
import IconFilter from "@components/icons/IconFilter.vue";
import IconDropdown from "@components/icons/IconDropdown.vue";
import {FwbCheckbox} from 'flowbite-vue'
import Checkbox from "@components/reusable/Checkbox.vue";
import {useWindowSize} from '@vueuse/core'


export default defineComponent({
  components: {Checkbox, FwbCheckbox, IconDropdown, IconFilter},
  props: {
    filters: {
      type: Object,
      default: {
        years: []
      }
    },
    filterHandler: {
      type: Function,
      default: () => {
      }
    },
    blockHeight: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      title: 'יאר',
    }
  },
  methods: {},
  setup(props) {
    const isMobile = ref(false)
    const status = ref(false)
    const selected = ref<any>([]);
    const {width} = useWindowSize()
    const modal = ref(false);

    const toggle = () => {
      status.value = !status.value
    }

    const openModal = () => {
      modal.value = true
      status.value = true;
      document.body.classList.add('overflow-hidden')
    }
    const closeModal = () => {
      modal.value = false
      document.body.classList.remove('overflow-hidden')
    }
    const resetFilter = () => {
      selected.value = [];

      modal.value = false
      document.body.classList.remove('overflow-hidden')
    }

    watch(selected, (current: any) => {
      props.filterHandler(current);
    });

    const mobileDetect = (w:number) => {
      isMobile.value = w < 1024;
    }

    watch(width, (w: number) => {
      mobileDetect(w)
    })

    onMounted(() => {
      modal.value = false
      mobileDetect(width.value)
    });

    onUnmounted(() => {
      document.body.classList.remove('overflow-hidden')
    })

    return {
      isMobile, selected, toggle, status, openModal, closeModal, resetFilter, modal
    }
  }
})
</script>